import { string } from '@/shared/libs/yup';
import { HookFormField, FieldInputProps } from '@/shared/libs/hook-form';

export const citySchema = string().label('City');

export const CityField = (props: FieldInputProps) => <HookFormField.Input label="City" {...props}/>;